    <template>
    <tr :class="updates[name] == 'update' ? 'me-changed' : 'me-no-change'">
        <td>
            <select class="form-control" v-model="updates[name]">
                <option value="original">Keep Original</option>
                <option value="update">Update</option>
            </select>
        </td>
        <td>
            <slot></slot>
        </td>
        <td>
            {{ stats[name].enabled }}
            {{ enabled }}
        </td>
        <td>
            {{ stats[name].disabled }}
            {{ disabled }}
        </td>
    </tr>
</template>

<script>
    export default {
        props: [
            'name',
            'updates',
            'stats',
            'watch',
            'watch2',
            'watch3'
        ],
        data() {
            return {
            };
        },
        watch: {
            watch() {
                this.updates[this.name] = 'update';
            },
            watch2() {
                this.updates[this.name] = 'update';
            },
            watch3() {
                this.updates[this.name] = 'update';
            }
        },
        computed: {
            enabled() {
                return this.stats[this.name].language == 'enabled/disabled'
                    ? 'enabled' : 'filled';
            },
            disabled() {
                return this.stats[this.name].language == 'enabled/disabled'
                    ? 'disabled' : 'empty';
            }
        }
    }
</script>

<style scoped>
    .me-changed {
        background: #eee;
    }
</style>